import React from 'react';
import { Component } from '../../../../dispatcher/modules';
import { PUZZLE_FIELD_STATE } from '../Types';
import { PUZZLE_DATE_RANGE_PROPS } from './Types';
import _ from 'lodash';
import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import {
  ABSTRACT_FIELD_OMITTED_PROPS,
  FIELD_OMITTED_PROPS
} from '../../../../utility';
import Field from '../../../layout/field/Field';
import CustomDateInput from './CustomDateInput';
import Container from '../../../layout/container/Container';

class PuzzleDateRange extends Component<PUZZLE_DATE_RANGE_PROPS, PUZZLE_FIELD_STATE> {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      ...props
    };
  }

  static defaultProps = {
    size: 'medium'
  }

  onChange = (e) => {
    let { value } = this.state;
    this.props?.onChange(e);
  }
  /**
   * Validate date field
   */
  private validateField = (min: Date | undefined, value: Date | null | undefined, valid: boolean | undefined) => true

  /**
   * Accessibility - adding aria-label
   * Adding event listener on calendar
   */
  private datePickerOnFocus = (e: any) => {
    if (e.target.classList.contains('k-input-inner')) {
      let ariaLabel = this.props.label;
      if (this.props.ariaLabelLocale) {
        ariaLabel = this.props.ariaLabelLocale;
      }
      e.target.setAttribute('aria-label', `${ariaLabel}`);
    }
  };
  
  render() { 
    let rangeProps = { ...this.props };
    const datePickerOmittedProps = ['required'].concat(ABSTRACT_FIELD_OMITTED_PROPS, FIELD_OMITTED_PROPS);
    let defaultRangeProps: any = _.omit(rangeProps, datePickerOmittedProps);
    let { value } = defaultRangeProps;

    if (!_.isDate(value) && _.isString(value)) {
      value = new Date(value);
      defaultRangeProps = { ...defaultRangeProps, value };
    }

    const isValid = this.validateField(defaultRangeProps.min, defaultRangeProps.value, defaultRangeProps.valid);

    const {
      asField,
      ariaDescribedBy,
      errorTxt,
      size,
      labelClassName,
      withValidation,
      fieldClassName = '',
      fieldMandatory,
      fieldWithAdditionalEl,
      datePickerLabel,
      endInputLabel,
      startInputLabel
    } = this.props;

    const asFieldProps = {
      fieldClassName,
      fieldMandatory,
      fieldWithAdditionalEl
    };

    const endDateInputSettings = {
      label: endInputLabel,
      labelClassName: labelClassName,
      placeholder: ' ',
      size: size,
      valid: isValid
    };

    const startDateInputSettings = {
      ...endDateInputSettings,
      label: startInputLabel
    };

    const content = (
      <div
        className={`tp-daterangepicker-input k-d-flex-col ${fieldMandatory ? 'k-mandatory' : ''}`}
        data-cy={'datepickerWrap'}
      >
        <Container displayFlex>
          <span className={'tp-datepicker-label'}>{datePickerLabel}</span>
          <DateRangePicker
            onChange={this.onChange}
            endDateInput={CustomDateInput}
            startDateInput={CustomDateInput}
            endDateInputSettings={endDateInputSettings}
            startDateInputSettings={startDateInputSettings}
            {...defaultRangeProps}
          />
        </Container>
        {withValidation && <div
          className={'tp-validation-error-message'}
          id={ariaDescribedBy}
        >
          {errorTxt}
        </div>}
      </div>
    );

    if (asField) {
      return (
        <Field {...asFieldProps}>
          {content}
        </Field>
      );
    }

    return content;
  }
}
export default PuzzleDateRange;
